import moment from 'moment';
import { displayShortDate } from '../Format/Format';

const distributionFrequencyMap = {
    ANNUAL: 'Annual',
    QUARTERLY: 'Quarterly',
    MONTHLY: 'Monthly',
    NOT_APPLICABLE: 'N/A'
};

const getFriendlyFrequency = (f) =>
    distributionFrequencyMap[f] || distributionFrequencyMap.NOT_APPLICABLE;

export const fundDetailSplitRowUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const returnData = [];
    const {
        price: { price, pricePercentChange },
        ytdMonthlyTotalReturns
    } = gqlResult.mutualFund;
    returnData.push({
        label: 'NAV AS OF x/x/xx',
        value: price
    });
    returnData.push({ label: 'NAV DAILY CHANGE', value: pricePercentChange });
    returnData.push({ label: 'YTD RETURN', value: ytdMonthlyTotalReturns });
    returnData.push({ label: 'MORNINGSTAR RATING', value: 5 });

    return returnData;
};

export const summaryKeyFactsBottom = (gqlResult) => {
    if (!gqlResult) return null;
    const returnData = [];
    const { cusip, inceptionDate, taxID } = gqlResult.mutualFund;

    returnData.push([
        { label: 'INCEPTION DATE', value: inceptionDate },
        { label: 'TAX ID', value: taxID }
    ]);
    returnData.push([{ label: 'CUSIP', value: cusip }]);

    return returnData;
};

export const summaryKeyFactsMid = (gqlResult) => {
    if (!gqlResult) return null;
    const returnData = [];
    const {
        openToNewInvestors,
        riskLevelName,
        morningStarCateogryName,
        expenseRatio,
        minimumInvestmentAmount,
        assetClassName
    } = gqlResult.mutualFund;

    returnData.push([
        { label: 'FUND STATUS', value: openToNewInvestors },
        { label: 'ACCOUNT MINIMUM', value: minimumInvestmentAmount }
    ]);
    returnData.push([
        { label: 'INVESTMENT RISK', value: riskLevelName },
        { label: 'EXPENSE RATIO', value: expenseRatio }
    ]);
    returnData.push([
        { label: 'MORNINGSTAR CATEGORY', value: morningStarCateogryName },
        { label: 'ASSET CLASS', value: assetClassName }
    ]);

    return returnData;
};

export const summaryKeyFactsTop = (gqlResult) => {
    if (!gqlResult) return null;
    const returnData = [];
    const {
        netAssets,
        price: { priceChange, pricePercentChange }
    } = gqlResult.mutualFund;
    const pricePercentChangeValue =
        pricePercentChange !== undefined ? pricePercentChange : '';
    returnData.push([
        {
            label: 'NET ASSET VALUE',
            value: `$ ${netAssets}`
        },
        {
            label: 'NAV DAILY CHANGE',
            value: `$${priceChange} (${pricePercentChangeValue}%)`
        }
    ]);
    return returnData;
};

export const summaryChartUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const { assetAllocationRankings } = gqlResult.mutualFund;
    const data = [
        ['Information Technology', 40.8],
        ['Consumer Discretionary', 23.1]
    ];
    const [{ asOfDate }] = assetAllocationRankings;
    const returnData = {
        data: [...data],
        legend: data.map(([l, v]) => ({ label: l, value: v })),
        asOfDate: displayShortDate(asOfDate)
    };
    return returnData;
};

export const overviewNumbersTableUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const returnData = [
        { label: 'YTD RETURN', value: '?' },
        { label: 'CURRENT PRICE', value: gqlResult.mutualFund.price.price },
        { label: '52 WK HIGH', value: '?' },
        { label: 'INVESTMENT RISK', value: '?' },
        { label: 'INCEPTION DATE', value: gqlResult.mutualFund.inceptionDate },
        {
            label: 'YIELD (TTM)',
            value: gqlResult.mutualFund.yield
        },
        { label: 'DAILY PRICE CHANGE', value: '?' },
        { label: '52 WK LOW', value: '?' },
        { label: 'EXPENSE RATIO', value: gqlResult.mutualFund.expenseRatio },
        {
            label: 'ASSETS UNDER MANAGEMENT',
            value: gqlResult.mutualFund.totalAssets
        }
    ];
    return returnData.map((ele) => ({
        label: ele.label,
        value: ele.value
    }));
};

export const morningstarRatingsTableUtil = (gqlResult) => {
    if (!gqlResult) return null;
    // const {
    //     mutualFund: {
    //         morningStarRatings: {
    //             morningStarOverallRating,
    //             morningStar3YearRating,
    //             morningStar5YearRating,
    //             morningStar10YearRating
    //         }
    //     }
    // } = gqlResult;
    const title = 'Morningstar Ratings';
    const returnData = [
        {
            label: 'Overall',
            values: [{ val1: 5 }]
        },
        {
            label: '3 Years',
            values: [{ val1: 4 }]
        },
        {
            label: '5 Years',
            values: [{ val1: 1 }]
        },
        {
            label: '10 Years',
            values: [{ val1: 3 }]
        }
    ];

    return { data: returnData, title };
};

export const fundValueAndEarningsUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const {
        mutualFund: {
            netAssets,
            medianMarketCapitalization,
            priceEarningsRatio,
            earningsGrowthRate3Years,
            monthlyComponentsAsOfDate: asOfDate
        }
    } = gqlResult;
    const title = 'Fund Value & Earnings';
    const returnData = [
        {
            label: 'Price/Earnings Ratio (Domestic)',
            values: [{ val1: priceEarningsRatio }]
        },
        {
            label: 'Earnings Growth Rate (Domestic)',
            values: [{ val1: earningsGrowthRate3Years }]
        },
        {
            label: 'Median Market Capitalization',
            values: [{ val1: medianMarketCapitalization }]
        },
        {
            label: 'Net Assets',
            values: [{ val1: netAssets }]
        }
    ];
    return { data: returnData, title, asOfDate: displayShortDate(asOfDate) };
};

export const dividendPaymentsUtil = (gqlResult) => {
    if (!gqlResult) {
        return null;
    }
    const {
        mutualFund: {
            dividendPayments // eslint-disable-line no-unused-vars
        }
    } = gqlResult;
    const title = 'Dividend Distribution History';
    /** change this to real data once its in dev */
    const data = [
        {
            label: '12/15/2017',
            values: [
                { 'per-share-amt': '1.50%' },
                { 'reinvestment-price': '$110' }
            ]
        },
        {
            label: '12/15/2016',
            values: [
                { 'per-share-amt': '16.43%' },
                { 'reinvestment-price': '$105' }
            ]
        },
        {
            label: '12/15/2014',
            values: [
                { 'per-share-amt': '42.57%' },
                { 'reinvestment-price': '$98' }
            ]
        }
    ];
    return {
        data,
        title,
        headers: ['Date', 'Per Share Amount', 'Reinvestment Price']
    };
};

export const fundSplitUtil = (gqlResult) => {
    if (!gqlResult) {
        return null;
    }
    const {
        mutualFund: { fundSplits }
    } = gqlResult;
    const title = 'Share Splits';
    const data = fundSplits.map((s) => ({
        label: moment(s.effectiveDate, moment.ISO_8601).format('MM/DD/YYYY'),
        values: [
            {
                'post-split-net-asset-value': s.postSplitNetAssetValue
            },
            { 'pre-split-net-asset-value': s.preSplitNetAssetValue },
            { description: s.splitTypeDescription }
        ]
    }));
    return {
        data,
        title,
        headers: ['Date', 'Post-Split Price', 'Pre-Split Price', 'Description']
    };
};

export const distributionScheduleUtil = (gqlResult) => {
    if (!gqlResult) {
        return null;
    }
    const {
        mutualFund: { dividendFrequency, capitalGainFrequency }
    } = gqlResult;
    return {
        dividendFrequency: getFriendlyFrequency(dividendFrequency),
        capitalGainFrequency: getFriendlyFrequency(capitalGainFrequency)
    };
};

export const publicOfferingFilterUtil = (funds = [], date = new Date()) => {
    const filteredFunds = funds.filter(
        (fund) =>
            fund.publicOfferingDate && new Date(fund.publicOfferingDate) <= date
    );

    return filteredFunds;
};
